// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/NavBar';
import HomePage from './components/HomePage';
import BookingAgentPage from './components/BookingAgentPage';
import PrendreRendezVousPage from './components/PrendreRendezVousPage';
import WeeklyAvailabilityPage from './components/WeeklyAvailabilityPage';
import ReservationPage from './components/ReservationPage';
import LoginPage from './components/LoginPage';
import PatientDashboard from './components/PatientDashboard';
import MesRendezvous from './components/MesRendezvous';
import MonDossierSante from './components/MonDossierSante';
import MonProfil from './components/MonProfil';
import ProfessionalDashboard from './components/ProfessionalDashboard';
import ModifierProfilPro from './components/ModifierProfilPro';
import AjouterSpecialite from './components/AjouterSpecialite';
import AddServiceProfessional from './components/AddServiceProfessional';
import AddAvailability from './components/AddAvailability';
import FicheDescriptivePage from './components/FicheDescriptivePage';
import ProfessionalAgenda from './components/ProfessionalAgenda';
import Calendrier from './components/Calendrier';
import DetailRdv from './components/DetailsRdv';
import ReservationConfirmation from './components/ReservationConfirmation';
import RescheduleConfirmation from './components/RescheduleConfirmation';
import Clients from './components/Clients';
import ClientProfile from './components/ClientProfile';
import AddNote from './components/AddNote';
import WaitingList from './components/WaitingList';
import WaitingListPage from './components/WaitingListPage';
import WaitingListAccept from './components/WaitingListAccept';
import WaitingListDecline from './components/WaitingListDecline';
import Paiement from './components/Paiement';
import MesFactures from './components/MesFactures';
import ConfirmationFinal from './components/ConfirmationFinal';
import AdminPatients from './components/AdminPatients';
import AdminProfessionals from './components/AdminProfessionals';
import AdminRendezVous from './components/AdminRendezVous';
import AdminStats from './components/AdminStats';
import AdminDashboard from './components/AdminDashboard';
import ConfirmRdvPage from './components/ConfirmRdvPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import './front.css';
import Footer from './components/Footer';
import '@fortawesome/fontawesome-free/css/all.min.css';
import RegisterProfessional from './components/RegisterProfessional';
import VerifyEmail from './components/VerifyEmail';
import RedirectAfterLogin from './components/RedirectAfterLogin';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import TelemedRoom from './components/TelemedRoom';
import TelemedJoin from './components/TelemedJoin';
import SoinsADomicile from './components/SoinsADomicile';
import SanteMentale from './components/SanteMentale';
import BienEtre from './components/BienEtre';
import AnalysesSang from './components/AnalysesSang';
import LivraisonMedicamentsPage from './components/LivraisonMedicamentsPage';
import TelemedClientSessions from './components/TelemedClientSessions';


import { AuthProvider } from './components/AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';
import { CareCoordinatorProvider } from './care/CareCoordinatorContext';

import 'react-big-calendar/lib/css/react-big-calendar.css';


function App() {

  return (
    <LanguageProvider>
      <AuthProvider>
        <CareCoordinatorProvider>
          <Router>
            <div className="app-shell">
              <Navbar />
              <main className="app-content">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/booking" element={<BookingAgentPage />} />
                  <Route path="/prestation-de-service" element={<Navigate to="/booking" replace />} />
                  <Route path="/prendre-rendez-vous/:professionalId" element={<PrendreRendezVousPage />} />
                  <Route path="/disponibilites/:professionalId" element={<WeeklyAvailabilityPage />} />
                  <Route path="/reservation/:professionalId" element={<ReservationPage />} />
                  <Route path="/connexion" element={<LoginPage />} />
                  <Route path="/redirect-after-login" element={<RedirectAfterLogin />} />
                  <Route path="/patient/dashboard" element={<ProtectedRoute allowedRoles={['patient']}><PatientDashboard /></ProtectedRoute>} />
                  <Route path="/patient/rendez-vous" element={<ProtectedRoute allowedRoles={['patient']}><MesRendezvous /></ProtectedRoute>} />
                  <Route path="/patient/dossier" element={<ProtectedRoute allowedRoles={['patient']}><MonDossierSante /></ProtectedRoute>} />
                  <Route path="/patient/profil" element={<ProtectedRoute allowedRoles={['patient']}><MonProfil /></ProtectedRoute>} />
                  <Route path="/patient/factures" element={<ProtectedRoute allowedRoles={['patient']}><MesFactures /></ProtectedRoute>} />
                  <Route path="/professional/dashboard" element={<ProtectedRoute allowedRoles={['professional']}><ProfessionalDashboard /></ProtectedRoute>} />
                  <Route path="/professional/profil" element={<ProtectedRoute allowedRoles={['professional']}><ModifierProfilPro /></ProtectedRoute>} />
                  <Route path="/professional/ajouter-specialite" element={<ProtectedRoute allowedRoles={['professional']}><AjouterSpecialite /></ProtectedRoute>} />
                  <Route path="/professional/ajouter-service" element={<ProtectedRoute allowedRoles={['professional']}><AddServiceProfessional /></ProtectedRoute>} />
                  <Route path="/professional/add-availability" element={<ProtectedRoute allowedRoles={['professional']}><AddAvailability /></ProtectedRoute>} />
                  <Route path="/patient/rdv" element={<Navigate to="/booking" replace />} />
                  <Route path="/fiche-professionnel/:id" element={<FicheDescriptivePage />} />
                  <Route path="/professional/agenda" element={<ProtectedRoute allowedRoles={['professional']}><ProfessionalAgenda /></ProtectedRoute>} />
                  <Route path="/professional/calendrier" element={<ProtectedRoute allowedRoles={['professional']}><Calendrier /></ProtectedRoute>} />
                  <Route path="/patient/rdv/:appointmentId" element={<ProtectedRoute allowedRoles={['patient']}><DetailRdv /></ProtectedRoute>} />
                  <Route path="/reservation/confirmation" element={<ReservationConfirmation />} />
                  <Route path="/mon-profil" element={<ProtectedRoute allowedRoles={['patient']}><MonProfil /></ProtectedRoute>} />
                  <Route path="/reprogrammation/:appointmentId/proposition/:proposalId" element={<RescheduleConfirmation />} />
                  <Route path="/professional/clients" element={<ProtectedRoute allowedRoles={['professional']}><Clients /></ProtectedRoute>} />
                  <Route path="/professional/clients/:id" element={<ProtectedRoute allowedRoles={['professional']}><ClientProfile /></ProtectedRoute>} />
                  <Route path="/professional/clients/:id/add-note" element={<ProtectedRoute allowedRoles={['professional']}><AddNote /></ProtectedRoute>} />
                  <Route path="/waiting-list" element={<WaitingList />} />
                  <Route path="/patient/waitinglistpage" element={<ProtectedRoute allowedRoles={['patient']}><WaitingListPage /></ProtectedRoute>} />    
                  <Route path="/waiting-list/:request_id/accept" element={<WaitingListAccept />} />
                  <Route path="/paiement/:appointmentId" element={<Paiement />} />
                  <Route path="/waiting-list/:request_id/decline" element={<WaitingListDecline />} />
                  <Route path="/paiement" element={<Paiement />} />
                  <Route path="/confirmation-final" element={<ConfirmationFinal />} />
                  <Route path="/admin/patients" element={<AdminPatients />} />
                  <Route path="/admin/professionnels" element={<AdminProfessionals />} />
                  <Route path="/admin/rendezvous" element={<AdminRendezVous />} />
                  <Route path="/admin/statistiques" element={<AdminStats />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/confirm-rdv/:id" element={<ConfirmRdvPage />} />
                  <Route path="/devenir-prestataire" element={<RegisterProfessional />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/telemed/:sessionId" element={<TelemedRoom />} />
                  <Route path="/telemed/:sessionId/join" element={<TelemedJoin />} />
                  <Route path="/services/soins-a-domicile" element={<SoinsADomicile />} />
                  <Route path="/services/sante-mentale/" element={<SanteMentale />} />
                  <Route path="/services/bien-etre/" element={<BienEtre />} />
                  <Route path="/services/analyses-de-sang" element={<AnalysesSang />} />
                  <Route path="/services/livraison-de-medicaments" element={<LivraisonMedicamentsPage />} />
                  <Route path="/professional/clients/:patientId/telemed" element={<ProtectedRoute allowedRoles={['professional']}><TelemedClientSessions /></ProtectedRoute>} />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </CareCoordinatorProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
